export class RoleMember {
    id: any;
    departmentId: any;
    name!: string;
    userName!: string;
    department!: string;
    email!: string;
    role!: number;
    roleName!: string;
    fullNameAndDepartmentName!: string;
    memberType!: RoleMemberTypes;
}


export enum RoleMemberTypes {
    Person = 1,
    Department = 2
}